import React from "react";
import { useDispatch } from "react-redux";
import { Grid } from "semantic-ui-react";
import InputField from "../../../commonComponents/formComponents/inputField";
import {
  saveLineItemFeild,
  updateLineItemFeild
} from "../../actions";

 function ProductTag(props) {
 
    const {
        lineItemIndex,
        isFormDisabled,
        sku,
        invoiceIndex,
        invoiceId,
        merchandiseId,
        translate
      } = props;
    const dispatch = useDispatch();

  

    return (
        <Grid.Column
        width="3"
        className="divFormFeild b-rw-0"
      >
        <InputField
          isLabel={false}
          id={`sku-${invoiceId}-${merchandiseId}`}
          type="text"
          label={translate("SKU",{ns:["default","lineItem"]})}
          mandatory={false}
          value={sku}
          className={"field-bg"}
          clearInput={false}
          disabled={
            isFormDisabled 
          }
          onChange={(value) => {
            dispatch(updateLineItemFeild(invoiceId, merchandiseId, { sku: value }))
          
          }}
          onBlur={(value) => {
            dispatch(saveLineItemFeild(merchandiseId, 'sku', invoiceId))
         
          }}
        />

      </Grid.Column>
    )
}

export default  React.memo(ProductTag);